import { render, staticRenderFns } from "./VectorMapsPage.vue?vue&type=template&id=21a802ce&"
import script from "./VectorMapsPage.vue?vue&type=script&lang=js&"
export * from "./VectorMapsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports